module.exports = __webpack_public_path__ + "img/twwky3.4b09b33f.jpg";